export default (axios, payload) => axios.post('/checkout/error', payload);
